var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mc-seg"},_vm._l((_vm.options),function(opt){return _c('button',{key:opt.value,class:{ 'is-on': _vm.value === opt.value },attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('input', opt.value)}}},[_vm._v(" "+_vm._s(opt.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }